/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered () {
      console.log('Service worker foi registrado.')
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('Novo conteúdo está sendo carregado.')
    },
    updated () {
      console.log('Novo conteúdo está disponível; Recarregar aplicação.')
      window.location.reload(true)
    },
    offline () {
      console.log('Não foi encontrado conexão com a Internet. A aplicação está rodando offline.')
    },
    error (error) {
      console.error('Erro durente o registro do service worker:', error)
    }
  })
}
